/**
 * 插入官员
 * Author:Bai.Zhiming
 * 2019-6-3
 */
angular.module('insertLeaderModule', []).
controller("insertLeaderCtrl", ['$scope', '$modalInstance', 'trsHttpService', 'siteId', function($scope, $modalInstance, trsHttpService, siteId) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {

        };
        $scope.data = {
            selectedLeaders: []
        };
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        getLeaderList();
    }
    /**
     * [getLeaderList description] 获取官员列表
     * @return {[type]} [description]
     */
    function getLeaderList() {
        let params = {
            serviceid: "mlf_appexchange",
            methodname: "getZJXWOfficers",
            SiteId: siteId
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(resp => {
            $scope.data.leaderList = resp.DATA.officer_list;
        });
    }
    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };
    /**
     * [confirm description] 确定
     * @return {[type]} [description]
     */
    $scope.confirm = function() {
        $modalInstance.close($scope.data.selectedLeaders);
    };
}]);